import { formatStandardDate } from "../dates.js";
const dateListToCalendarDates = (dates) => {
  if (!dates || !dates.length) {
    return [];
  }
  const calendarDates = [];
  for (const date of dates) {
    if (typeof date === "string") {
      calendarDates.push(date);
    } else if (date instanceof Date) {
      calendarDates.push(formatStandardDate(date));
    } else {
      const [fromDate, toDate] = date;
      if (!fromDate) {
        continue;
      }
      calendarDates.push(
        toDate ? `${formatStandardDate(fromDate)}:${formatStandardDate(toDate)}` : formatStandardDate(fromDate)
      );
    }
  }
  return calendarDates;
};
const formatMonthHeader = (date, locale) => {
  const formatter = new Intl.DateTimeFormat(locale, { month: "long", year: "numeric" });
  return formatter.format(date);
};
const getSingleCalendarTemplate = ({ dsf_mobile }) => {
  return `
  ${dsf_mobile ? '<div class="calendar-mobile-header" data-month-label></div>' : ""}
  <div class="vanilla-calendar-wrapper">
  <div class="vanilla-calendar-content">
    <#Week />
    <#Days />
  </div>
</div>
<#ControlTime />`;
};
const getRangeCalendarTemplate = ({ dsf_mobile }) => {
  return `<div class="vanilla-calendar-grid">
  <#Multiple>
    <div class="vanilla-calendar-column">
    ${dsf_mobile ? '<div class="calendar-mobile-header" data-month-label></div>' : ""}
      <div class="vanilla-calendar-wrapper">
        <div class="vanilla-calendar-content">
          ${dsf_mobile ? "" : "<#Week />"}
          <#Days />
        </div>
      </div>
    </div>
  <#/Multiple>
</div>
<#ControlTime />`;
};
export {
  dateListToCalendarDates,
  formatMonthHeader,
  getRangeCalendarTemplate,
  getSingleCalendarTemplate
};
